module.exports = __webpack_public_path__ + "static/img/aboutUs2.82eb0964.png";